import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TodoService } from '../../todo.service';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { Preference } from '../../preference.model';

@Component({
  selector: 'todo-settings-side-nav',
  templateUrl: './settings-side-nav.component.html',
  styleUrls: ['./settings-side-nav.component.scss']
})
export class SettingsSideNavComponent implements OnInit {

  @Input()
  preference: Preference;
  @Output()
  update: EventEmitter<any> = new EventEmitter();
  isLoading = false;
  userId: string;
  constructor(
    private todoService: TodoService,
    private localUser: LocalUserService
  ) {
    this.userId = this.localUser.getUserId();
  }

  ngOnInit() {
  }


  updatePreferences(type) {
    this.isLoading = true;
    this.preference[type] = !this.preference[type]
    this.todoService.updatePreferences(this.userId, this.preference)
      .subscribe((items) => {
        this.preference = items;
        this.update.emit();
        this.isLoading = false;
      }, (err) => console.log(err));
  }


}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/settings-side-nav/settings-side-nav.component.ts